/**
 * Marvicci — améliorations légères (aucune dépendance).
 *  1. Barre d'achat fixe mobile (fiche produit)
 *  2. Lien « Commander via WhatsApp » synchronisé avec la variante sélectionnée
 *  3. Événements clients : clic WhatsApp (mv_whatsapp_click) et envoi de formulaire (mv_lead_submit)
 *     Publiés via Shopify.analytics.publish : consommés par un pixel personnalisé (Paramètres → Événements clients),
 *     qui respecte le consentement. Aucun pixel Meta/GA4 n'est codé ici. Aucune donnée personnelle dans la charge utile.
 */
(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  /* ---------------------------------------------------------------- 1. Barre d'achat fixe */
  function initStickyBar() {
    var bar = document.querySelector('[data-mv-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;

    // Sorti du bloc produit : un ancêtre animé (transform) casserait position: fixed.
    document.body.appendChild(bar);
    var sectionId = bar.getAttribute('data-section-id');
    var priceSlot = bar.querySelector('[data-mv-sticky-price]');
    var stickyButton = bar.querySelector('[data-mv-sticky-btn]');
    var stickyLabel = stickyButton.querySelector('span');
    var visible = false;
    var observed = null;

    function mainButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      bar.hidden = !next;
      document.body.classList.toggle('mv-sticky-atc-on', next);
    }

    // Recopie l'état (libellé, désactivé) et le prix du bloc principal : Dawn les remplace à chaque changement de variante.
    function sync() {
      var button = mainButton();
      if (button) {
        stickyButton.disabled = button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true';
        var span = button.querySelector('span');
        var text = (span ? span.textContent : button.textContent).trim();
        if (text) stickyLabel.textContent = text;
      }
      var price = document.getElementById('price-' + sectionId);
      var source = price && price.querySelector('.price');
      if (source && priceSlot) {
        var html = source.outerHTML;
        if (priceSlot.getAttribute('data-html') !== html) {
          priceSlot.innerHTML = html;
          priceSlot.setAttribute('data-html', html);
        }
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      setVisible(mobileQuery.matches && !entries[0].isIntersecting);
    });

    function observe() {
      var button = mainButton();
      if (button && button !== observed) {
        if (observed) observer.unobserve(observed);
        observer.observe(button);
        observed = button;
      }
    }

    stickyButton.addEventListener('click', function () {
      var button = mainButton();
      if (button && !button.disabled) button.click();
    });

    mobileQuery.addEventListener('change', function () {
      if (!mobileQuery.matches) setVisible(false);
    });

    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(function (mutations) {
      // Ignore les mutations provoquées par la barre elle-même (évite toute boucle).
      if (mutations.every(function (m) { return bar.contains(m.target); })) return;
      sync();
      observe();
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    sync();
    observe();
  }

  /* ---------------------------------------------------------------- 2. WhatsApp produit + variante */
  function initProductWhatsApp() {
    var link = document.querySelector('a[data-mv-wa-template]');
    if (!link || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    var template = link.getAttribute('data-mv-wa-template');
    if (!template) return; // produit sans variantes : message fixe, rien à mettre à jour

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      var url = link.getAttribute('data-mv-wa-product-url') + '?variant=' + variant.id;
      var message = template.replace('__VARIANT__', variant.title).replace('__URL__', url);
      link.href = link.getAttribute('data-mv-wa-base') + '?text=' + encodeURIComponent(message);
    });
  }

  /* ---------------------------------------------------------------- 3. Événements clients */
  function publishEvent(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* le suivi ne doit jamais gêner l'utilisateur */ }
  }

  function pageContext() {
    var main = document.querySelector('main[data-template]');
    return { template: main ? main.getAttribute('data-template') : '', path: window.location.pathname };
  }

  function initTracking() {
    var lastWhatsApp = 0;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-mv-whatsapp]');
      if (!link) return;
      var now = Date.now();
      if (now - lastWhatsApp < 1000) return; // un seul événement par clic (anti-doublon)
      lastWhatsApp = now;
      var payload = pageContext();
      payload.placement = link.getAttribute('data-mv-whatsapp');
      publishEvent('mv_whatsapp_click', payload);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('mv-form')) return;
      var button = form.querySelector('[data-mv-lead]');
      var payload = pageContext();
      payload.form_type = button ? button.getAttribute('data-mv-lead') : 'unknown';
      publishEvent('mv_lead_submit', payload);
    });
  }

  function init() {
    initStickyBar();
    initProductWhatsApp();
    initTracking();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
